import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (login, senha) => api.post('/auth/login', { login, senha }),
};

export const tenantsAPI = {
  list: () => api.get('/tenants'),
  get: (id) => api.get(`/tenants/${id}`),
  create: (data) => api.post('/tenants', data),
  update: (id, data) => api.put(`/tenants/${id}`, data),
  delete: (id) => api.delete(`/tenants/${id}`),
  // Gestão Manual de Assinatura
  gerenciarAssinatura: (id, data) => api.post(`/tenants/${id}/assinatura/gerenciar`, data),
  // Histórico
  historicoPagamentos: (id) => api.get(`/tenants/${id}/historico-pagamentos`),
  // Plano automatizado
  ativarPlano: (id, data) => api.post(`/tenants/${id}/ativar-plano`, data),
  // Pagamento manual
  pagamentoManual: (id, data) => api.post(`/tenants/${id}/pagamento-manual`, data),
  // Estender trial
  estenderTrial: (id, data) => api.post(`/tenants/${id}/trial/estender`, data),

  // Mercado Pago
  mpCriarAssinatura: (id, data) => api.post(`/tenants/${id}/mp/criar-assinatura`, data),
  mpVerificar: (id) => api.get(`/tenants/${id}/mp/verificar`),
  mpCancelar: (id) => api.post(`/tenants/${id}/mp/cancelar`),
  mpReenviarLinkAssinatura: (id) => api.post(`/tenants/${id}/mp/reenviar-link-assinatura`),
  mpGerarTaxaInstalacao: (id, data) => api.post(`/tenants/${id}/mp/cobranca-instalacao`, data || {}),
  mpGerarPixMensal: (id, data) => api.post(`/tenants/${id}/mp/cobranca-pix-mensal`, data || {}),
  // Histórico
  getHistorico: (id) => api.get(`/tenants/${id}/historico-assinatura`),
  // Manutenção
  toggleManutencao: (id, data) => api.put(`/tenants/${id}/manutencao`, data),
  toggleManutencaoGlobal: (data) => api.put('/tenants/manutencao/global', data),
  // Mensalidade
  alterarMensalidade: (id, data) => api.put(`/tenants/${id}/mensalidade`, data),
  // Indicação
  atualizarIndicacao: (id, data) => api.put(`/tenants/${id}/indicacao`, data),
  // Módulos Extras (Add-ons)
  toggleModuloFinanceiro: (id, data) => api.put(`/tenants/${id}/modulos-extras/financeiro`, data),
  toggleModuloWhatsapp: (id, data) => api.put(`/tenants/${id}/modulos-extras/whatsapp`, data),
  // Cobrança detalhada (plano + add-ons)
  getCobrancaDetalhe: (id, plano = 'monthly') => api.get(`/tenants/${id}/cobranca-detalhe`, { params: { plano } }),
  // Reconciliação Mercado Pago (rede de segurança contra webhook falho)
  mpReconciliarAgora: (id) => api.post(`/tenants/${id}/mp/reconciliar-agora`),
};

export const mpAdminAPI = {
  getHealth: () => api.get('/admin/mp/health'),
  getWebhookLogs: (params) => api.get('/admin/mp/webhook-logs', { params }),
  reconciliarTodos: () => api.post('/cron/reconciliar-mp'),
};

export const dashboardAPI = {
  overview: () => api.get('/dashboard/overview'),
};

export const relatoriosAPI = {
  indicacoes: () => api.get('/relatorios/indicacoes'),
};

export const mpAPI = {
  getConfig: () => api.get('/mp/config'),
};

export const statsAPI = {
  get: () => api.get('/stats'),
};

export const ticketsAPI = {
  list: (params) => api.get('/tickets', { params }),
  get: (id) => api.get(`/tickets/${id}`),
  responder: (id, mensagem) => api.post(`/tickets/${id}/responder`, { mensagem }),
  updateStatus: (id, status) => api.put(`/tickets/${id}/status`, { status }),
  getStats: () => api.get('/tickets/stats'),
};

export const baseConhecimentoAPI = {
  list: () => api.get('/base-conhecimento'),
  create: (data) => api.post('/base-conhecimento', data),
  update: (id, data) => api.put(`/base-conhecimento/${id}`, data),
  delete: (id) => api.delete(`/base-conhecimento/${id}`),
};

export default api;
